/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>修改商家基本信息 - {{serv.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search"></el-form>

    <el-form label-width="120px" :model="serv" ref="serv">
      <el-form-item label="商家名称" prop="name">
        <el-input size="small" v-model="serv.name" auto-complete="off" placeholder="请输入商家名称"></el-input>
      </el-form-item>
      <el-form-item label="商家图片" prop="name">
        <el-upload class="avatar-uploader" action="http://39.107.109.196:14400/file/restaurant/ossUpload"
          :data="{ servId: serv.mchId, picType: 2 }" :show-file-list="false" name="imgFile"
          :on-success="handleAvatarSuccess">
          <img v-if="serv.pictureUrl" :src=" serv.pictureUrl"
            class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="餐厅地址" prop="name">
        <el-input size="small" v-model="serv.addr" auto-complete="off" placeholder="请输入餐厅地址"></el-input>
      </el-form-item>
      <el-form-item label="城市" prop="name">
        <el-select v-model="serv.cityId" filterable remote placeholder="请输入关键词" size="medium"
          :remote-method="getCityList" @change="getAreaList">
          <el-option v-for="item in options" :key="item.cityId" :label="item.cityName" :value="item.cityId">
          </el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="区域" prop="name">
        <el-select v-model="serv.areaId" placeholder="请选择区域">
          <el-option v-for="item in arealist" :key="item.areaId" :label="item.areaName" :value="item.areaId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="纬度" prop="name">
        <el-input size="small" v-model="serv.lat" auto-complete="off" placeholder="请输入纬度"></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="name">
        <el-input size="small" v-model="serv.longt" auto-complete="off" placeholder="请输入经度"></el-input>
      </el-form-item>
      <el-form-item label="人均消费" prop="name">
        <el-input size="small" v-model="serv.avg" auto-complete="off" placeholder="请输入人均消费"></el-input>
      </el-form-item>
      <el-form-item label="成本价" prop="name">
        <el-input size="small" disabled v-model="serv.rateBase" auto-complete="off" placeholder="请输入成本价"></el-input>
      </el-form-item>
      <el-form-item label="销售价" prop="name">
        <el-input size="small" v-model="serv.rateSale" auto-complete="off" placeholder="请输入销售价"></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="name">
        <el-input size="small" v-model="serv.remark" auto-complete="off" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="商家电话" prop="name">
        <el-input size="small" v-model="serv.mchTel" auto-complete="off" placeholder="请输入商家电话"></el-input>
      </el-form-item>
      <el-form-item label="商家编号" prop="name">
        <el-input size="small" v-model="serv.mchCode" auto-complete="off" placeholder="请输入商家编号"></el-input>
      </el-form-item>
      <el-form-item label="开发票" prop="name">
        <el-select v-model="serv.invoiceFrom" placeholder="请选择谁开发票">
          <el-option v-for="item in invoiceFrom" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="基础类型" prop="name">
        <el-select v-model="serv.type" placeholder="请选择区域" filterable remote size="medium"
          :remote-method="getMerchantTypeList">
          <el-option v-for="item in type" :key="item.typeId" :label="item.typeName" :value="item.typeId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品牌" prop="name">
        <el-select style="width:100%" v-model="serv.groupId" filterable remote placeholder="请输入关键词" size="medium"
          :remote-method="getMchGroupListPage" >
          <el-option v-for="item in jituan" :key="item.groupId" :label="item.groupName" :value="item.groupId">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
      <el-button size="small" @click="$router.back(-1)">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">修改
      </el-button>
    </div>

  </div>
</template>

<script>
  import {
    merchantDetail,
    getCityList,
    getAreaList,
    getMchGroupListPage,
    getMerchantTypeList,
    updateMerchantInfo
  } from '../../api/userMG'
  export default {
    data() {
      return {
        mchId: this.$route.query.id,
        serv: '',
        serv2: '',
        invoiceFrom: [{
            id: 1,
            name: '商家开发票'
          },
          {
            id: 2,
            name: '平台开发票'
          }
        ],
        options: [],
        city_code: '',
        bankCode: '',
        type: [],
        jituan: [],
        arealist: [],
      }
    },

    created() {
      this.getMchGroupListPage()
      this.merchantDetail()
      this.getMerchantTypeList()
    },
    methods: {
      getMerchantTypeList(query) {
        this.type = []
        let pro = {
          "name": query,
        }
        getMerchantTypeList(pro).then(res => {
          this.type = res.data
        })
      },
      getCityList(query) {
        this.options = []
        let pro = {
          "name": query,
        }
        getCityList(pro).then(res => {
          this.options = res.data
        })
      },
      getAreaList(query) {
        let pro = {
          cityId: this.serv.cityId
        }
        getAreaList(pro).then(res => {
          this.arealist = res.data
        })
      },
      getMchGroupListPage(query) {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": 1,
          "pageSize": 10,
          "name": query,
        }
        getMchGroupListPage(pro)
          .then(res => {
            if (res.code == 0) {
              this.jituan = res.data.list
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      },
      merchantDetail() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "mchId": this.mchId
        }
        merchantDetail(pro).then(res => {
          this.serv = JSON.parse(JSON.stringify(res.data))
          this.serv.cityId = this.serv.cityId.toString()
          this.getCityList()
          this.getAreaList()

          this.serv2 = JSON.parse(JSON.stringify(res.data))
        })
      },
      submitForm() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "mchId": this.mchId,
          name: this.serv.name,
          addr: this.serv.addr,
          pictureUrl: this.serv.pictureUrl,
          longt: this.serv.longt,
          lat: this.serv.lat,
          cityId: this.serv.cityId,
          areaId: this.serv.areaId,
          avg: this.serv.avg,
          remark: this.serv.remark,
          invoiceFrom: this.serv.invoiceFrom,
          groupId: this.serv.groupId,
          type: this.serv.type,
          rateSale: this.serv.rateSale,
          mchTel: this.serv.mchTel,
          mchCode: this.serv.mchCode,
        }
        updateMerchantInfo(pro).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.$router.push({
              name: '商家管理'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      },
      handleAvatarSuccess(res, file) {

        this.serv.pictureUrl = res.data.fileDownloadUri;
      },

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/bus/modifyMerchantsBasis.vue